import comp from "./DiscardLearningGoalsModal";
export default comp;
